import React from "react";
import { Table, Tooltip, Button, Popconfirm } from "antd";
import API from "API";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { DISPLAY_MODE } from "Constants";
import { formatDate } from "Utils";

export default function Documents({
  documents = [],
  mode = DISPLAY_MODE.READ_ONLY,
  onRemove,
  ...props
}) {
  return (
    <Table
      {...props}
      scroll={{ y: 600 }}
      bordered
      rowKey={(row) => row.id}
      dataSource={documents}
      columns={[
        {
          title: "Doküman",
          dataIndex: "documentName",
        },
        {
          title: "Yaratılma Tarihi",
          dataIndex: "createdAt",
          render: (text, record) => formatDate(record.releaseDate),
        },
        {
          title: "İşlemler",
          width: 180,
          fixed: "right",
          dataIndex: "operation",
          render: (text, record, index) => (
            <span>
              <Tooltip title="İndir" placement="bottom">
                <Button
                  type="default"
                  style={{ marginRight: 8 }}
                  onClick={async () => {
                    const data = await API.get(
                      `/documents/downloadDoc/${record.referenceType.id}/documentnames/${record.documentOriginalName}/false`,
                      {
                        responseType: "blob",
                      }
                    ).then((response) => {
                      var a = window.document.createElement("a");
                      window.document.body.appendChild(a);
                      a.style = "display: none";
                      let url = URL.createObjectURL(response);
                      a.href = url;
                      a.download = record.documentOriginalName;
                      a.click();
                      window.document.body.removeChild(a);
                    });
                  }}
                >
                  <FontAwesomeIcon icon={["fas", "download"]} />
                </Button>
              </Tooltip>
              {mode === DISPLAY_MODE.EDIT ? (
                <Popconfirm
                  title="Emin Misin?"
                  onConfirm={async () => {
                    await API.delete(
                      `/documents/deleteFile/${record.referenceType.id}/documentnames/${record.documentOriginalName}`
                    ).then((response) => {
                      if (onRemove) onRemove();
                    });
                  }}
                  icon={
                    <FontAwesomeIcon
                      icon={["far", "trash-alt"]}
                      style={{ color: "red" }}
                    />
                  }
                  okText="Kaldır"
                  cancelText="Geri"
                >
                  <Tooltip title="Kaldır" placement="bottom">
                    <Button type="danger">
                      <FontAwesomeIcon icon={["far", "trash-alt"]} />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              ) : null}
            </span>
          ),
        },
      ]}
      size="small"
      pagination={false}
    />
  );
}
